import Map from '../../common/js/mapYandex';

export default new class Contacts {
    constructor() {
        this.contactsPage = '[data-contacts-page]';

        if (!$(this.contactsPage).length) return;

        this.map = '.contacts__map';

        this.initMaps();
    }

    initMaps() {
        let arMaps = $(this.map);

        arMaps.map((i, item) => {
            let id = $(item).attr('id'),
                cord = [$(item).data('lat'),$(item).data('long')],
                title = $(item).data('title'),
                text = $(item).data('text');

            Map.createMaps(id, cord, 16, title, text)
        })
    }
}
